import { Button } from '@mui/material'
import React, { useEffect } from 'react'
import { useCancelDisbursementBatchMutation } from '../../../../api-services/payments/paymentsApi'
import { RtkQueryHelper } from '../../../../api-services/shared/RtkQueryHelper'
import { useAppDispatch } from '../../../../app/hooks'
import { setNotification } from '../../../components/ui-widgets/uiWidgetsSlice'
import { type BatchIdActionProps } from './DisbursementBatchPage'

const CancelDisbursementBatch: React.FC<BatchIdActionProps> = ({ disbursementBatch }: BatchIdActionProps) => {
  const dispatch = useAppDispatch()

  const [apiCancelBatchTrigger, apiCancelBatchResult] = useCancelDisbursementBatchMutation()
  const handleCancelBatch = async (): Promise<void> => {
    const choice = window.confirm(
      'Are you sure you want to cancel the processing of this disbursement batch?'
    )
    if (choice) {
      await apiCancelBatchTrigger(disbursementBatch.disbursementBatchId)
    }
  }

  useEffect(() => {
    if (apiCancelBatchResult.isSuccess) {
      dispatch(setNotification({ open: true, severity: 'success', message: `Disbursement batch ${apiCancelBatchResult.data.disbursementBatchId} cancelled.` }))
    }

    if (apiCancelBatchResult.isError) {
      dispatch(setNotification({ open: true, severity: 'error', message: RtkQueryHelper.mapResponseError(apiCancelBatchResult.error) }))
    }
  }, [apiCancelBatchResult.isSuccess, apiCancelBatchResult.isError])

  return (
    <>
      <Button type={'button'} variant={'contained'} color={'warning'} disabled={!disbursementBatch.cancelable} onClick={handleCancelBatch}>
        Cancel Batch
      </Button>
    </>
  )
}

export default CancelDisbursementBatch
